import {
  FormItem,
  InputNumber as FaveInputNumber,
  InputNumberProps,
} from 'fave-ui';
import styles from './style.module.css';
import { getIn, useFormikContext } from 'formik';
import { cn } from '../../../helpers/cn';
import { useEffect } from 'react';

type Props<T> = {
  name: keyof T;
  label: string;
} & InputNumberProps;

const InputNumber = <T extends {}>({
  name,
  label,
  className,
  ...restProps
}: Props<T>) => {
  const {
    errors,
    touched,
    handleBlur,
    values,
    setFieldValue,
    setFieldTouched,
  } = useFormikContext<T>();

  const isArrayField = name.includes('.');

  const innerValue = isArrayField ? getIn(values, name) : values[name];
  const error = isArrayField ? getIn(errors, name) : errors[name];
  const isTouched = isArrayField ? getIn(touched, name) : touched[name];
  const helpText = isTouched && error !== undefined && error;

  // trigger validate on change
  // does not work when implemented inside handleOnChange
  useEffect(() => {
    if (innerValue || innerValue === 0) setFieldTouched(name, true, true);
  }, [innerValue]);

  const handleOnChange = (value: string | number | null) =>
    setFieldValue(name, value);

  const handleOnBlur = () => {
    handleBlur(name);
    setFieldTouched(name, true, true);
  };

  return (
    <FormItem
      className={styles.formItem}
      label={label}
      validateStatus={error !== undefined && isTouched ? 'error' : 'success'}
      help={helpText}
    >
      <FaveInputNumber
        {...restProps}
        value={innerValue}
        type="number"
        className={cn(className, styles.inputNumber)}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        onWheel={e => e.currentTarget.blur()}
        controls={false}
      />
    </FormItem>
  );
};

export default InputNumber;
